var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container",class:{ 'chart-container--embedded': _vm.embedded }},[_c('chart',{attrs:{"height":"100%","width":"100%","embedded":_vm.embedded,"path":_vm.path1,"id":_vm.id1,"params":_vm.params1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }